import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core'
import { CmsLinkType } from '../../../enums/cms-link-type'

@Component({
  selector: 'mb-category-navigation-logo',
  templateUrl: './mb-category-navigation-logo.component.html',
  styleUrls: ['./mb-category-navigation-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MbCategoryNavigationLogoComponent {
  @Output() logoClick = new EventEmitter<Event>()
  protected readonly cmsLinkType = CmsLinkType
}
